import { Link } from "react-router-dom";
import { AlertCircle, FileText } from "lucide-react";
import { useState } from "react";
import { fmtDate } from "@/lib/finance";
import { SEMAPHORE } from "@/lib/conecta";
import { PrivateBadge, SemDot } from "@/components/conecta/Bits";
import { OnePageViewer } from "@/components/conecta/OnePageViewer";
import { ClosedBadge } from "@/components/conecta/ClosedBadge";

export const OppCard = ({ o, stages, onMove, compact }) => {
  const [viewing, setViewing] = useState(false);
  const who = [o.names?.[o.requester_id], o.names?.[o.resolver_id]].filter(Boolean).join(" → ");
  return (
    <div data-testid="opportunity-card-item" className={`c-card overflow-hidden flex ${compact ? "w-64 shrink-0" : ""}`}>
      <span className={`w-1.5 shrink-0 ${SEMAPHORE[o.semaphore]?.dot || "bg-slate-400/30"}`} />
      <div className="flex-1 min-w-0 p-3.5 space-y-1.5">
        <Link to={`/conecta/negocios/${o.id}`} className="block space-y-1">
          <div className="flex items-start justify-between gap-2">
            <p data-testid="opportunity-card-title" className="font-semibold leading-snug">{o.title}</p>
            <div className="flex flex-col items-end gap-1 shrink-0">
              {o.one_page && (
                <button data-testid="opportunity-card-onepage-btn" aria-label="Ver one page principal" title={o.one_page.original_filename}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); setViewing(true); }}
                  className="flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded border border-[#bc9538]/50 c-accent">
                  <FileText className="w-3 h-3" /> One page
                </button>
              )}
              <PrivateBadge show={o.is_private_only_me} />
              {o.type === "del_despacho" && <span className="text-[10px] px-1.5 py-0.5 rounded border c-line c-muted">Despacho</span>}
            </div>
          </div>
          <p className="text-xs c-text-2 truncate">{who || "Partes sin definir"}</p>
          <ClosedBadge o={o} testid="opportunity-card-closed-badge" />
          {!compact && <p className="text-xs c-muted flex items-center gap-1.5"><SemDot value={o.semaphore} size="w-2 h-2" /> {stages[o.stage] || o.stage}</p>}
          <p className={`text-xs flex items-center gap-1 ${o.overdue ? "text-red-600 dark:text-red-400 font-semibold" : "c-muted"}`}>
            {o.overdue && <AlertCircle className="w-3 h-3" />}
            {o.next_step_text || "Sin próximo paso"}{o.next_step_date ? ` · ${fmtDate(o.next_step_date)}` : ""}
          </p>
        </Link>
        {onMove && (
          <select data-testid="opportunity-card-move-select" value={o.stage} onChange={(e) => onMove(o, e.target.value)} className="c-input !py-1.5 !text-xs">
            {Object.entries(stages).map(([k, v]) => <option key={k} value={k}>Mover a: {v}</option>)}
          </select>
        )}
      </div>
      {o.one_page && <OnePageViewer pg={viewing ? o.one_page : null} open={viewing} onOpenChange={setViewing} />}
    </div>
  );
};
